import SkeletonLoader from './index';

const ParentDashboardSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse">
      {/* Metric Cards */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <SkeletonLoader
            key={i}
            width="100%"
            height={116} // Approx height of SummaryCard
            className="rounded-xl"
          />
        ))}
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[3fr_2fr]">
        <SkeletonLoader width="100%" height={400} className="rounded-xl" />
        <SkeletonLoader width="100%" height={400} className="rounded-xl" />
      </div>

      {/* Current Game Table */}
      <div className="rounded-xl border border-neutral-light-200 bg-white p-4">
        <SkeletonLoader width={200} height={28} className="mb-4" />
        <div className="space-y-4">
          <SkeletonLoader width="100%" height={48} />
          {[1, 2, 3].map((i) => (
            <SkeletonLoader key={i} width="100%" height={64} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ParentDashboardSkeleton;
